module.exports = __webpack_public_path__ + "static/media/view event info.434efe87.svg";